import React from 'react';
import './style.css';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

const validationSchema = Yup.object({
	mobileNumber: Yup.string()
		.matches(/^[0-9]{10}$/, 'Mobile number must be exactly 10 digits')
		.required('Mobile number is required'),
});

const DematSection = () => {

	return (
		<>
			<section>
				<div className="container">
					<div className="row">
						<div className="col my-lg-5">
							<div className="row">
								<div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-2">
									<div className="demat-banner mb-4 p-md-5">
										<div className="p-2 py-4 py-md-0">
											<div className=" text-center row">
												<div className="fs-42 ur_ebold lh-50 text-white mb-3 demat-title">
													Open free demat account in 5 minutes
												</div>
												<div className="col-md-10 col-lg-8 col-xl-7 mx-md-auto">
													<Formik
														initialValues={{ mobileNumber: '' }}
														validationSchema={validationSchema}
														onSubmit={(values) => {
															window.location.href = `https://signup.jainam.in/?mobile=${values.mobileNumber}&page_url=${process.env.REACT_APP_MAIN_WEBSITE_URL}`;
														}}>
														{({ handleSubmit, setFieldValue }) => (
															<Form onSubmit={handleSubmit}>
																<div className="d-md-flex gap-3">
																	<div className=" mb-4 mb-md-0">
																		<div className="input-group py-3 border rounded-3 w-100">
																			<span
																				className="input-group-text bg-transparent in_med text-white border-0 border-end py-0"
																				id="basic-addon1">
																				+91
																			</span>
																			<Field
																				name="mobileNumber"
																				type="text"
																				className="form-control bg-transparent text-white in_med bs-none shadow-none border-0 py-0"
																				placeholder="Enter mobile number"
																				aria-label="Enter mobile number"
																				aria-describedby="basic-addon1"
																				onChange={(e: any) => {
																					const value = e.target.value.replace(/\D/g, '');
																					if (value.length <= 10) {
																						setFieldValue('mobileNumber', value);
																					}
																				}}
																			/>
																		</div>
																		<ErrorMessage
																			name="mobileNumber"
																			component="div"
																			className="text-danger text-start in_semi"
																		/>
																	</div>
																	<div className="">
																		<button
																			type="submit"
																			className="bg-color31 btn demat-btn fs-16 in_semi p-3 text-nowrap demat-style-btn">
																			Open Demat Account
																		</button>
																	</div>
																</div>
															</Form>
														)}
													</Formik>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default DematSection;
